<template>
<div class="swiper-container">
			<ol class="breadcrumb swiper-no-swiping position-fixed"></ol>
			<!-- Additional required wrapper -->
			<div class="swiper-wrapper">
				<!--Portada General-->

				<!--SLIDE-1-->
				<div class="swiper-slide overflow-auto swiper-no-swiping" data-title="Créditos">
					<div class="container-fluid">
						<div class="row">
							<div class="col-lg-6 col-md-12 col-sm-12 col-12 mt-3 d-flex justify-content-center FondoCreditos">
								<div class="col-lg-6 col-md-12 col-sm-12 col-12  mt-3 text-center">
									<img src="recursos/img/cc-icon.png" class="img-fluid mt-5" alt="">
									<h4 class="my-5 text-left font-italic text-white"><span class="text-white">ITM Institución Universitaria</span><br>Facultad de Artes y Humanidades <br>Interpretación y Traducción Lengua de Señas Colombiana - Español</h4>
									<div class="mb-5">
										<p class="text-left text-white"><span class="font-weight-bold">Nombre del curso:</span> Introducción a la Lingüística</p>
										<p class="text-left text-white"><span class="font-weight-bold">Unidad académica:</span> Adquisición del lenguaje</p>
										<p class="text-left text-white"><span class="font-weight-bold">Palabras clave:</span> innatismo, psicolingüística, desarrollo</p>
										<p class="text-left text-white"><span class="font-weight-bold">Fecha de creación:</span> mayo de 2020</p>
										<p class="text-left text-white"><span class="font-weight-bold">Experto en contenidos</span><br>Wilfer León Arias Loaiza</p>
										<p class="text-left text-white"><span class="font-weight-bold">Par evaluador</span><br>Dally Ortiz Quintero</p>
										<p class="text-left text-white"><span class="font-weight-bold">Asesora pedagógica</span><br>Vanessa Ramírez Córdoba </p>
									</div>
								</div>
							</div>
							<div class=" bg-ref col-lg-6 col-md-12 col-sm-12 col-12 pt-xl-5 pt-lg-5 pt-0 pl-4 pr-4 mt-xl-3 mt-lg-3 mt-0">
								<div class="row d-flex justify-content-center">
									<div class="col-lg-8 col-md-12 col-sm-12 col-12">
										<h4 class="col-Uni3 mt-5 col03-Uni4"><span class="font-italic">Producción</span></h4> <br>
										<p class="col-Uni3 col03-Uni4">Instituto Tecnológico Metropolitano (ITM)</p> <br>
										<h4 class="col-Uni3 col03-Uni4"><span class="font-italic">Licencia de uso del OVA</span></h4><br>
										<p class="col-Uni3 col03-Uni4">Este recurso digital es propiedad del Instituto Tecnológico Metropolitano (ITM) para el uso de los profesores y estudiantes adscritos a la Institución.</p>
										<p class="col-Uni3 col03-Uni4">Este material académico puede contener, además de fuentes referenciadas, algunas relacionadas con el área de estudio que no cuentan con fechas ni autores específicos y respetan los derechos del autor, ya que se utilizan para fines educativos no comerciales y atendiendo al bien común sin causar perjuicios a los titulares.</p>
										<p class="col-Uni3 col03-Uni4">Adicionalmente, contiene citas textuales de más de 40 palabras, que, para observarlas en su forma original y de manera correcta según las Normas APA, deberán ser consultadas en la versión imprimible de este objeto virtual de aprendizaje.</p>		
										<p class="col-Uni3 col03-Uni4">Las imágenes de apoyo utilizadas en este material son de uso libre, por lo tanto si los autores deciden eliminarlas, es probable que no estén en internet en el momento de consulta.</p>
									</div>
								</div>
								<br>
								<div class="row d-flex justify-content-center text mb-5">									
									<div class="col-12 col-lg-4 col-md-12 col-sm-12 text-center mb-5">
										<h4 class="col03-Uni4 mb-4">Creado por:</h4>
										<img src="recursos/img/logo-itm.png" class="img-fluid" alt="">
									</div>
									<div class="col-12 col-lg-4 col-md-12 col-sm-12 text-center">
										<p class="col-Uni3 col03-Uni4"><span class="font-italic">Esta licencia permite a otros distribuir, remezclar, retocar, y crear a partir de tu obra de modo no comercial, siempre y cuando te den crédito y licencien sus nuevas creaciones bajo las mismas condiciones.</span></p>
									</div>
								</div>
							</div>
						</div>
					</div>
				</div>
				<!--SLIDE-1-->
			</div>
		</div>
</template>

<script>

import {SwiperController} from '../assets/RecursosITM/js/Swiper'

export default {
    name: 'Creditos',
    mounted() {
        SwiperController(), // Cargar controladores de Swiper
        document.title = this.$route.meta.title // Cambiar el título de la página
    },
}
</script>